import { Grid, ResponsiveValue } from '@chakra-ui/react';
import Heading from '@legacy-vfuk/core-heading';
import _ from 'lodash';
import { rem } from 'polished';
import { FC, useMemo } from 'react';
import { useLocation } from '@reach/router';

import SWProductStrip from '@/components/pageBuilder/Elements/SWProductStrip';
import { SWProductStripProps } from '@/components/pageBuilder/Elements/SWProductStrip/SWProductStrip.types';

import { WrapSimpleGrid } from './SWProductList.styles';
import { SWProductListProps } from './SWProductList.types';
import { useSessionContext } from '@/contexts/UserSessionContext';

const SWProductList: FC<SWProductListProps> = ({ items = [] }: SWProductListProps) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const filter = params.get('filter');
  const { searchValue } = useSessionContext();

  const filterParams = filter != null && filter.length > 0 ? filter.split('&') : [];

  const displayedItemsWithSearch = useMemo(() => {
    let filteredItems = items;
    if (filterParams.length > 0) {
      filteredItems = filteredItems.filter(item => filterParams.includes(item.category.name));
    }

    if (searchValue.length > 0) {
      filteredItems = filteredItems.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase()));
    }

    return filteredItems;
  }, [searchValue, items, filterParams]);

  const renderCards = (items: SWProductStripProps[]) => {
    if (items.length > 0) {
      return items
        .filter(
          item =>
            item.__typename === 'ContentfulMarketplaceMultipleProducts' ||
            (item.__typename === 'ContentfulMarketplaceProduct' && !item.includeOnly)
        )
        .map(card => <SWProductStrip key={card.id} {...card} />);
    }
    return <Heading level={3} justify="center" text="No Products Found" />;
  };

  const gridGap = {
    base: '1rem',
    md: '1.25rem',
  } as ResponsiveValue<string>;

  const maxWidth = {
    base: '21.5625rem',
    md: '73.75rem',
  } as ResponsiveValue<string>;
  return (
    <WrapSimpleGrid backgroundColor="#f4f4f4" p={`${rem('50px')} ${rem('16px')}`}>
      <Grid
        sx={{
          gap: gridGap,
          gridAutoRows: '1fr',
          alignContent: 'center',
          maxWidth: maxWidth,
          margin: 'auto',
        }}
      >
        {renderCards(
          displayedItemsWithSearch.map(item => ({
            ...item,
            monthly: { gross: _.random(100, true).toFixed(2) },
          })) as SWProductStripProps[]
        )}
      </Grid>
    </WrapSimpleGrid>
  );
};

export default SWProductList;
